import React from 'react';
import PropTypes from 'prop-types';

import './index.css';

export const formatPercentage = (amount, toFixed) => {
  let displayString = '+ 0.00%';

  if (Number.isFinite(amount)) {
    if (amount >= 0) {
      displayString = `+ ${amount.toLocaleString('en-US', {
        style: 'decimal',
        useGrouping: true,
        minimumFractionDigits: toFixed,
        maximumFractionDigits: toFixed,
      })}%`;
    } else {
      displayString = `- ${Math.abs(amount).toLocaleString('en-US', {
        style: 'decimal',
        useGrouping: true,
        minimumFractionDigits: toFixed,
        maximumFractionDigits: toFixed,
      })}%`;
    }
  }
  return displayString;
};

const Percentage = ({ amount, toFixed, ...props }) => {
  const styleName = (Number.isFinite(amount) && amount < 0 ?
    'percentageNegative' : 'percentagePositive');

  return (
    <div
      styleName={styleName}
      {...props}
    >
      {formatPercentage(amount, toFixed)}
    </div>
  );
};

Percentage.propTypes = {
  amount: PropTypes.number,
  toFixed: PropTypes.number,
};

Percentage.defaultProps = {
  amount: null,
  toFixed: 2,
};

export default Percentage;



// WEBPACK FOOTER //
// ./src/components/Percentage/index.js